export const DEFAULT_CUSTOMER_THEME : CustomerTheme = {
    colors: ['#1446A0','#171738','#0A2E36','#F18F01','#120309','#710627','#6457A6 ','#008BF8 ','#261447','#58355E']
}


export interface CustomerTheme{
    colors: string[];
    headerLogoUrl?: string;
}